import { GenerateTokenResponseSchema, type GenerateTokenResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useCustomerPortalToken(
  customerId: string,
  options?: CustomUseQueryOptions<GenerateTokenResponse>,
) {
  const getCustomerPortalTokenQuery = useQuery(
    queryKeys.customerPortalToken(customerId),
    async () => {
      const api = getPrivateApi();
      const getCustomerPortalTokenResponse = await api.generateToken({
        generateTokenRequest: {
          params: {
            customerId,
          },
        },
      });

      return GenerateTokenResponseSchema.parse(getCustomerPortalTokenResponse);
    },
    options,
  );

  return getCustomerPortalTokenQuery;
}
